import React, { ReactNode } from "react";
import { HtmlRenderBlock } from '../../misc/HtmlRenderBlock';
import { Avatar } from "../../misc";

import "./AvatarWithText.scss";

interface Props {

  /**
   * Image. This should be square as it'll get turned into a circle.
   */
  imageAlt: string;
  imageTitle: string;
  imageSrc: string;
  
  /**
   * Heading text
   */
  heading: ReactNode;

  /**
   * Description text
   */
  htmlString: string;
}

/**
 * Initally used in a set of three as part of 'Our Approach', this component is to convey a bitesize piece of information.
 * 
 * @status development
 */
export const AvatarWithText: React.FC<Props> = ({ imageAlt, imageTitle, imageSrc, heading, htmlString }) => {

  return (
    <div className="avatar-with-text">

      <div className="avatar-with-text__image">

        <Avatar
          alt={imageAlt}
          rounded
          source={imageSrc}
          title={imageTitle}
        />

      </div>

      <h3 className="avatar-with-text__heading">{heading}</h3>

      <HtmlRenderBlock
        htmlString={htmlString}
        tag="div"
      />

    </div>
  );
};
